Vue.component('app-legislation-index-screen', {
  props: {
    actlist: '',
  },

  computed: {
    filteredList() {
      return this.actlist.filter((acts) => {
        return acts.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {},
});



// WEBPACK FOOTER //
// ./resources/assets/js/legislation.js